// src/index.ts
import createClient from "openapi-fetch";
function createApiClient(options) {
  return createClient(options);
}
export {
  createApiClient
};
//# sourceMappingURL=index.mjs.map